@if (isLoggedIn) {
  <app-page-tour></app-page-tour>
}
<app-growler></app-growler>
@if (isLoggedIn) {
  <app-recent-alerts
    (hideGrowlersEvent)="svc.closeGrowlers()"
    [currentNetwork]="svc.currentNetwork"
    [isOpen]="svc.isGrowlersOpen"
  ></app-recent-alerts>
}

@if (svc.showQuickStart && featureService.showGettingStarted) {
  <div
    class="QuickStart"
    routerLink="/getting-started"
  ></div>
}
@if (apiService.tutorialActive) {
  <app-progress-bar></app-progress-bar>
}

<div class="root-app-loading-indicator">
  @if (svc.appLoading) {
    <app-loading-indicator [isLoading]="svc.appLoading"></app-loading-indicator>
  }
</div>
